import { GFCPrice, GFCSelectionButton } from "./GFCComponents";
import { Box, Typography, Chip } from "@mui/joy";
import { CheckCircle2 } from "lucide-react";

export const generateColumnDefs = (
    supplierComparisonResponse: any[],
    purchaseStrategy: "single" | "multiple" = "single",
    bestPrices: Record<string, { supplier: string; price: number }> = {},
    bestTotalSupplier?: string,
    itemSupplierSelections: Record<string, string> = {},
    onItemSupplierSelect?: (productName: string, supplierName: string) => void
) => {
    const columnDefs = [
        {
            field: "ProductName",
            headerName: "Product",
            pinned: "left",
            flex: 1,
            minWidth: 200,
            cellRenderer: (params: any) => {
                if (params.data?.isFooter) {
                    return (
                        <Box display={"flex"} alignItems={"center"} height={"100%"} px={1.5}>
                            <Typography level="body-xs" sx={{ fontWeight: 600 }}>
                                Total
                            </Typography>
                        </Box>
                    );
                }
                if (params.data?.isSelectionRow) {
                    return (
                        <Box display={"flex"} alignItems={"center"} height={"100%"} px={1.5}>
                            <Typography level="body-xs" sx={{ fontWeight: 600 }}>
                                Select Supplier
                            </Typography>
                        </Box>
                    );
                }
                // Return the product name for regular rows
                return (
                    <Box
                        display={"flex"}
                        flexDirection="column"
                        justifyContent="center"
                        height={"100%"}
                        gap={0.25}
                        px={1.5}
                    >
                        <Typography level="body-xs" sx={{ fontWeight: 500, lineHeight: 1.2 }}>
                            {params.value}
                        </Typography>
                        {params.data?.ProductCategory && (
                            <Typography
                                level="body-xs"
                                sx={{ color: "text.tertiary", fontSize: "0.7rem", lineHeight: 1.2 }}
                            >
                                {params.data.ProductCategory}
                            </Typography>
                        )}
                    </Box>
                );
            },
        },
        ...supplierComparisonResponse.map((supplier) => ({
            field: supplier.SupplierName,
            headerName: supplier.SupplierName,
            flex: 1,
            cellStyle: {
                margin: 0,
                padding: 0,
            },
            minWidth: 150,
            cellRenderer: (params: any) => {
                if (params.data?.isFooter) {
                    // Footer row: Show total price with best indicator
                    const isBest = bestTotalSupplier === supplier.SupplierName;
                    return <GFCPrice {...params} isBest={isBest} />;
                }
                if (params.data?.isSelectionRow) {
                    // Selection row: Show selection button
                    return <GFCSelectionButton {...params} purchaseStrategy={purchaseStrategy} />;
                }
                // Regular row: Show price with best price indicator
                const productName = params.data?.ProductName;
                const isBestPrice = bestPrices[productName]?.supplier === supplier.SupplierName;
                const isSelected = itemSupplierSelections[productName] === supplier.SupplierName;
                return (
                    <GFCPrice
                        {...params}
                        isBest={isBestPrice}
                        purchaseStrategy={purchaseStrategy}
                        isSelected={isSelected}
                        onItemSupplierSelect={onItemSupplierSelect}
                        productName={productName}
                        supplierName={supplier.SupplierName}
                    />
                );
            },
        })),
    ];

    return columnDefs;
};
